import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import {
  ChallengeActivityState,
  ChallengeActivityStoreModel,
  ChallengeActivityUIModel,
} from './challenge-activity.model';
import { ChallengeActivityStore } from './challenge-activity.store';

@Injectable({ providedIn: 'root' })
export class ChallengeActivityQuery extends QueryEntity<
  ChallengeActivityState,
  ChallengeActivityStoreModel,
  ChallengeActivityUIModel,
  'id'
> {
  constructor(protected override store: ChallengeActivityStore) {
    super(store);
  }

  readonly challengeActivities$ = this.entities$.pipe(
    map((activities) => {
      return activities.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    }),
  );

  readonly ongoingActivity$: Observable<ChallengeActivityUIModel | undefined> = this.challengeActivities$.pipe(
    map((activity) => activity.filter((a) => a.status === 'IN_PROGRESS')),
    map((activity) => activity[0]),
  );

  readonly inProgressChallengeActivityId$: Observable<string | undefined> = this.ongoingActivity$.pipe(
    map((activity) => activity?.id),
    distinctUntilChanged(),
  );
}
